module.exports = __webpack_public_path__ + "fonts/2d0d0de.woff2";